export default __webpack_public_path__ + "static/media/fb.4178d148.svg";